<template>
  <div class="confirm-popup-back-page">
    <div class="confirm-popup">
      <div class="confirm-popup-contents">
        <div class="confirm-popup-contents-title">
          {{ boxId === 320 ? "운세 결과를 확인해 볼까요?" : "결과를 확인해 볼까요?" }}
        </div>
        <div class="confirm-popup-contents-delete">
          {{ boxId === 320 ? "오늘의 운세를 보면 클로버를 드려요!" : "마이타로는 AI가 쪽집게 해석을 학습해\n맞춤형 해석 결과를 알려드려요" }}
        </div>
      </div>

      <div v-web v-if="!campaignData" class="price-tag-web">
        <span> 결제금액 </span>
        <span v-if="this.biggerPrice !==''" style="text-decoration: line-through">{{biggerPrice}}원</span>
        <span style="font-size: 18px; font-weight: 700; color: #000"> {{ smallerPrice}}원</span>
      </div>

      <div v-web v-else class="price-tag-web">
        <span> 결제금액 </span>
        <span v-if="this.biggerPrice !==''" style="text-decoration: line-through">{{ smallerPrice }}원</span>
        <span style="font-size: 18px; font-weight: 700; color: #000"> {{ formatAndDiscountPrice(tarotBoxData.salePriceWon)}}원</span>
      </div>


      <ShimmerImage
          v-if="boxId === 320"
          :src="require('@/tarot_box/pages/box_input_v2/assets/free-clover.png')"
          :imageStyle="{ width: '60vw' }"
          :heightRatio="325/567"
          :isCircle="false"
          :borderRadius="'10px'"/>

      <ShimmerImage
          v-else
          :src="'https://firebasestorage.googleapis.com/v0/b/tarot-gpt.appspot.com/o/dev%2Fpayment_popup_icon.png?alt=media&token=a05eec50-53eb-4cd4-92f4-62d642139ec9&_gl=1*100hlkx*_ga*MTc3MDIwMzQ1Ni4xNjg2MTg0MDU2*_ga_CW55HF8NVT*MTY5ODIzOTYzOC4zOTAuMS4xNjk4MjM5NjkyLjYuMC4w'"
          :imageStyle="{ width: '81vw' }"
          :heightRatio="0.55"
          :isCircle="false"
          :borderRadius="'10px'"/>

      <!-- 웹 버전 버튼 -->
      <div v-web class="confirm-popup-button-area">
        <div class="confirm-popup-button" v-wave @click="goBackToWebMain()">
          닫기
        </div>
        <div class="confirm-popup-button" v-wave @click="goWebCheckout()">
          <div v-if="campaignData" class="bloat text3 gray12">
            ✨점소문 {{ campaignData.discountAmount * 100 }}% 할인 적용!
          </div>
          결제하기
        </div>
      </div>

      <!-- 앱 버전 버튼 -->
      <div v-app class="confirm-popup-button-area">
        <div class="confirm-popup-button" v-wave @click="skipResultView()">
          다음에 보기
        </div>
        <div v-if="boxId===320" class="confirm-popup-button" v-wave @click="handleButtonFunction()">
          무료 결과 보기
        </div>
        <div v-else class="confirm-popup-button" v-wave @click="handleButtonFunction()">
          {{ boxPrice }}
          <svg @load="logEvents" class="clover-icon"
               xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.9562 9.9995C9.97081 9.98345 9.98533 9.96732 9.99976 9.95111C10.0142 9.96732 10.0287 9.98345 10.0433 9.9995C10.0287 10.0155 10.0142 10.0317 9.99976 10.0479C9.98533 10.0317 9.9708 10.0155 9.9562 9.9995ZM9.99976 18.0761C8.94734 19.2581 7.43637 19.999 5.75758 19.999C2.57775 19.999 0 17.3409 0 14.062C0 12.4904 0.592161 11.0615 1.55895 9.9995C0.592161 8.93748 0 7.50855 0 5.937C0 2.65808 2.57775 0 5.75758 0C7.43637 0 8.94734 0.740894 9.99976 1.92289C11.0522 0.740894 12.5632 0 14.242 0C17.4218 0 19.9995 2.65808 19.9995 5.937C19.9995 7.50855 19.4074 8.93748 18.4406 9.9995C19.4074 11.0615 19.9995 12.4904 19.9995 14.062C19.9995 17.3409 17.4218 19.999 14.242 19.999C12.5632 19.999 11.0522 19.2581 9.99976 18.0761Z" fill="#4BD1A9"/>
            <path d="M10.464 14.652C9.84 14.652 9.256 14.544 8.712 14.328C8.168 14.104 7.692 13.796 7.284 13.404C6.884 13.012 6.568 12.556 6.336 12.036C6.112 11.508 6 10.94 6 10.332C6 9.716 6.112 9.148 6.336 8.628C6.568 8.1 6.888 7.64 7.296 7.248C7.704 6.856 8.176 6.552 8.712 6.336C9.256 6.112 9.84 6 10.464 6C10.928 6 11.376 6.064 11.808 6.192C12.24 6.32 12.64 6.5 13.008 6.732C13.384 6.964 13.704 7.244 13.968 7.572L12.792 8.736C12.488 8.36 12.136 8.076 11.736 7.884C11.344 7.692 10.92 7.596 10.464 7.596C10.088 7.596 9.736 7.668 9.408 7.812C9.08 7.948 8.796 8.14 8.556 8.388C8.316 8.628 8.128 8.916 7.992 9.252C7.856 9.58 7.788 9.94 7.788 10.332C7.788 10.716 7.856 11.076 7.992 11.412C8.128 11.74 8.32 12.028 8.568 12.276C8.816 12.516 9.104 12.704 9.432 12.84C9.768 12.976 10.132 13.044 10.524 13.044C10.964 13.044 11.376 12.952 11.76 12.768C12.144 12.584 12.484 12.32 12.78 11.976L13.92 13.104C13.656 13.424 13.34 13.7 12.972 13.932C12.604 14.164 12.204 14.344 11.772 14.472C11.348 14.592 10.912 14.652 10.464 14.652Z" fill="black"/>
          </svg>
          결제
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getTarotUserInfo, purchaseBox} from "@/tarot_box/helper/mytarot_api";
import {mapGetters, mapActions} from "vuex";
import ShimmerImage from "@/tarot_box/components/shimmer/ShimmerImage.vue";
import {logEvent} from "@/tarot_box/helper/native_api";
import {goToMyTarotTab} from "@/common/app_webview_handler";

export default {
  components: { ShimmerImage},
  computed: {
    ...mapGetters(['user', 'tarotBoxes']),
  },
  emits: ['paymentDone', 'update-user-info', 'close', 'open-paywall'],
  props: {
    paymentPopupData: {
      type: Object,
    },
    tarotBoxHistoryId: {
      type: Number,
    },
    item:{
      type: Object,
    },
    boxId: Number,
    inputData: String,
    pickedCards: String,
    tarotBoxData: Object,
    userId: Number,
    userPhoneNumber: String,
    historyId: Number,
    inputTarotData: Array,
    campaignData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      userInfo: {},
      boxPrice: 0,
      smallerPrice: '',
      biggerPrice: '',
      boxTitle: '',
      isCloverPaywallActive: false,
    };
  },
  mounted() {
    this.findTarotBoxById();
    logEvent('boxinput_purchase_popup', {
    });
  },
  methods: {
    ...mapActions(['setTempInputData']),
    branchTitleByOsType() {
      let title;
      if (this.$isWeb()) {
        title = '결제하기';
      } else {
        title = this.paymentPopupData && this.paymentPopupData.title ? this.paymentPopupData.title : '결제하기';
      }
      return title;
    },
    findTarotBoxById() {
      this.boxPrice = this.tarotBoxData.salePrice;
      this.smallerPrice = this.addCommaToPrice(this.tarotBoxData.salePriceWon);
      this.biggerPrice = this.addCommaToPrice(this.tarotBoxData.originalPriceWon);
      this.boxTitle = this.tarotBoxData.title;
    },
    addCommaToPrice(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatAndDiscountPrice(price) {
      if (!price || price === 0) {return 0;}
      const discountAmount = price * this.campaignData.discountAmount;
      let totalPrice = price - discountAmount;
      totalPrice = Math.floor(totalPrice / 10) * 10;
      return this.addCommaToPrice(totalPrice);
    },
    goToMyTarotTab,
    async handleButtonFunction() {
      const apiResult = await getTarotUserInfo(this.userId, this.userPhoneNumber);
      this.userInfo = apiResult.data;

      if (this.userInfo.clover_balance < this.boxPrice) {
        let url = new URL(window.location.href);
        const buildNumber = parseInt(url.searchParams.get('build_number'));
        if(buildNumber >= 84){
          this.$emit('open-paywall');
        } else {
          let dataToSend = {action: 'showPayWall'};
          window.sendInfoToApp(JSON.stringify(dataToSend));
        }
      } else {
        await purchaseBox(this.userId, this.userPhoneNumber, this.historyId);
        this.$emit('paymentDone');
      }
    },
    skipResultView() {
      logEvent('boxinput_purchase_notnow_click', {
        "tarot_box_id": this.boxId,
        "tarot_box_name": this.boxTitle,
        "price": parseInt(this.smallerPrice.replace(/,/g, '')),
      });
      goToMyTarotTab();
    },
    goBackToWebMain() {
      logEvent('boxinput_purchase_notnow_click', {
        "tarot_box_id": this.boxId,
        "tarot_box_name": this.boxTitle,
        "price": parseInt(this.smallerPrice.replace(/,/g, '')),
      });
      window.history.back();
    },
    goWebCheckout() {
      logEvent('boxinput_purchase_gogo_click', {
        "tarot_box_id": this.boxId,
        "tarot_box_name": this.boxTitle,
        "price": parseInt(this.smallerPrice.replace(/,/g, '')),
      });

      let parsedUserInputData;
      if (typeof this.inputData === 'string') {
        try {
          parsedUserInputData = JSON.parse(this.inputData);
        } catch (error) {
          console.error('Error parsing inputData:', error);
          // 에러 처리 로직
          return;
        }
      } else {
        parsedUserInputData = this.inputData;
      }

      const userInputParams = parsedUserInputData.map(item =>
          `${encodeURIComponent(item.key)}=${encodeURIComponent(item.value)}`
      ).join('&');
      const pickedCardsParam = this.inputTarotData ? `&picked_cards=${encodeURIComponent(this.inputTarotData)}` : '';
      const campaignParam = this.campaignData
          ? `&campaign_code=${encodeURIComponent(this.campaignData.campaignCode)}`
          : '';

      this.$store.dispatch('setTempInputData', parsedUserInputData)
      this.$store.dispatch('setTempCardData', pickedCardsParam)

      const url = `/tarot_box/checkout/${this.boxId}?${userInputParams}${pickedCardsParam}${campaignParam}&is_web=true`;
      this.$router.push(url);
    },
    logEvents() {
      logEvent ('boxinput_purchase_popup', {
        "tarot_box_id": this.boxId,
        "tarot_box_name": this.boxTitle,
      });
    },
    closePaywall() {
      this.$emit('update-user-info');
      this.isCloverPaywallActive = false;
    },
  },
}
</script>

<style scoped>
.confirm-popup-back-page{
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100svh;
  background: rgba(0, 0, 0, 0.80);
}

.confirm-popup{
  position: absolute;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  gap: 40px;
  width: 90%;
  height: fit-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 15px;
  box-sizing: border-box;

  border-radius: 12px;
  background: #FFF;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
  z-index: 1001;
}

.confirm-popup-contents{
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
  gap: 12px;
}

.confirm-popup-contents-title{
  color: #000;
  text-align: center;
  font-size: 20px;
  font-weight: 700;
}

.confirm-popup-contents-delete {
  text-align: center;
  color: #000;
  font-size: 14px;
  font-weight: 400;
}

.confirm-popup-button-area {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 9px;
}

.confirm-popup-button {
  position: relative;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;

  background: #1E2352;
  color: #FFF;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 700;
}

.confirm-popup-button:first-child {
  background: #E9E9E9;
  color: #6E6E6E;
}

.confirm-popup-button:last-child {
  background: #1E2352;
  color: #FFF;
}

.clover-icon {
  margin: 0 6px 0 4px;
}

.price-tag-web{
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  gap: 6px;

  padding: 8px 22px;
  background: #F0F1F2;
  border-radius: 90px;
  margin-top: -20px;
  font-size: 14px;
  color: #747474;
}

@keyframes bloatMove {
  0%, 100% {
    transform: translate(-50%, 0);
  }
  50% {
    transform: translate(-50%, -2px);
  }
}

.bloat{
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background-image: url("@/tarot_box/pages/event_page/assets/bloat.png");
  background-size: contain;
  background-repeat: no-repeat;
  width: 145px;
  height: 32px;
  padding-top: 5px;
  animation: bloatMove 1s ease-in-out infinite;
}
</style>